export const isSta = () => (
  new URLSearchParams(window.location.search).get('wrapper-sta-detached') === 'true'
)

export const isKalaydo = () => (
  new URLSearchParams(window.location.search).get('wrapper-kal-detached') === 'true'
)

export const isGeneric = () => (
  new URLSearchParams(window.location.search).get('wrapper-gen-detached') === 'true'
)
